let $ = require('jquery');
let layui = require('../../lib/layui/layui');
// import  '../../lib/layui/layui';

let EZUIKit = require('../../lib/ezuikit-2.6');
let HkDevice = require('../../lib/hkDeviceControl');
let videoInitBo = false;
let accessToken, videoList, hkDevice, videoplay, wid, splitBasis, videoPlayList, loadingInstance;
function videoInitFn (token, list) {
  if (videoInitBo) {
    return;
  }
  videoInitBo = true;
  // var accessToken = window.top.videoOptions.accessToken;
  // var videoLisnt = window.top.videoOptions.vidvideo_listeoList;
  accessToken = token;
  videoList = list;
  //初始化云台控制功能
  hkDevice = new HkDevice();
  hkDevice.getAccessToken(accessToken);

  videoplay;
  wid = 0; //当前选中窗口
  splitBasis = 1; //窗口模式，1为单窗口，2为多窗口
  videoPlayList = []; //播放的视频列表
  videoPlayList[0] = videoList[0];
  // videoPlayList[3] = videoList[1];

  //萤石云无法实现，所以隐藏视频录制和截图功能
  // $("#playBackContent").hide();
  // $(".focal_control").css("margin-top", "75px");

  //构建视频列表
  // var videoListStr = "";
  //
  // for (var i = 0; i < videoList.length; i++) {
  //   videoListStr +=
  //     '<div index="' +
  //     i +
  //     '"><img src="" alt="" />' +
  //     videoList[i].name +
  //     "</div>";
  // }
  // $(".video_list").html(videoListStr);
  // $(".video_list>div:nth-child(1)").addClass("active");
  // videoInit(videoPlayList);
  //停止播放
  $("#stopControl").click(function () {
    videoPlayList[wid] = undefined;
    videoInit(videoPlayList);
    clearTimeout(videoTime)
    videoTime = setTimeout(function () {
      videoBoolean = true;
    }, 500)
  });

  //云台控制功能
  window.directionStart = function (direction) {
    var info = videoPlayList[wid];
    hkDevice.setPtzTurn(
      {
        deviceSerial: info.deviceSerial,
        channelNo: info.channelNo,
        direction: direction,
        speed: 1 //云台速度：0-慢，1-适中，2-快
      },
      function (data) { }
    );
  };

  //停止云台控制
  window.directionStop = function () {
    var info = videoPlayList[wid];
    hkDevice.setPtzStop(
      {
        deviceSerial: info.deviceSerial,
        channelNo: info.channelNo
      },
      function (data) { }
    );
  };

  //回放功能
  $("#playBack").unbind("click").click(function () {
    var info = videoPlayList[wid];

    console.log(layui)
    layui.use(["layer", "laydate"], function () {
      var layer = layui.layer;
      var laydate = layui.laydate;

      var str =
        `<div style="text-align: center;"><input placeholder="请选择开始时间" type="text" style="margin: 10px 10px;width: calc(100% - 20px);" class="layui-input" id="startTime">` +
        `<input placeholder="请选择结束时间" type="text" style="margin: 0px 10px;width: calc(100% - 20px);" class="layui-input" id="endTime">` +
        `<button type="button" id="playConfirm" style="margin-top:10px" class="layui-btn layui-btn-normal">确定</button></div>`;

      layer.open({
        title: "选择时间",
        type: 1,
        offset: "auto",
        area: ["200px", "200px"], //宽高
        content: str
      });
      var date = currentTime(new Date());
      console.log(date);

      laydate.render({
        elem: "#startTime", //指定元素
        type: "datetime",
        max: date.secondDate
      });

      laydate.render({
        elem: "#endTime", //指定元素
        type: "datetime",
        max: date.secondDate
      });

      $("#playConfirm").click(function () {
        var startTime = $("#startTime").val();
        var endTime = $("#endTime").val();
        if (startTime && endTime) {
          startTime = startTime
            .replace(/-/g, "")
            .replace(/:/g, "")
            .replace(/ /g, "");
          endTime = endTime
            .replace(/-/g, "")
            .replace(/:/g, "")
            .replace(/ /g, "");

          if (Number(startTime) > Number(endTime)) {
            layer.msg("开始时间晚于结束时间，请重新选择");
          } else {
            layer.closeAll("page");

            url =
              "ezopen://open.ys7.com/" +
              info.deviceSerial +
              "/" +
              info.channelNo +
              ".local.rec?begin=" +
              startTime +
              "&end=" +
              endTime;

            var oPlugin = {
              iWidth: $("#videoPlay").innerWidth(),
              iHeight: $("#videoPlay").innerHeight()
            };

            videoplay = new EZUIKit.EZUIPlayer({
              id: "videoPlay",
              autoplay: true,
              url: url,
              accessToken: accessToken,
              decoderPath: "/gkxt/video_plug-in/lib", //decoderPath：${window.YOUR_PATH};请在生产模式输入ezuikit.js的绝对路径
              width: oPlugin.iWidth,
              height: oPlugin.iHeight,
              splitBasis: 1,
              // handleError: handleError,
              handleSuccess: function () {
                $(".draw-window").click(function () {
                  wid = $(this).attr("wid");
                });
              }
            });
          }
        } else {
          layer.msg("请选择时间");
        }
      });
    });
  });

  //录制
  $("#recordVideo").click(function () {
    alert("暂不支持录制功能")
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
  });
  //截图
  $("#printscreen").click(function () {
    var info = videoPlayList[wid];
    hkDevice.setPtzCapture(
      {
        deviceSerial: info.deviceSerial,
        channelNo: info.channelNo
      },
      function (data) {
        window.open(data.data.picUrl);
      }
    );
  });

  //多窗口
  // $("#multiwindow").unbind("click").click(function() {
  //   alert(1)
  //   splitBasis = splitBasis == 1 ? 2 : 1;
  //   videoInit(videoPlayList);
  // });

  // $("#multiwindow1").unbind("click").click(function() {
  //   splitBasis = splitBasis == 1 ? 3 : 1;
  //   videoInit(videoPlayList);
  // });

  //解析时间
  function currentTime (date) {
    var day = date;
    var Year = 0;
    var Month = 0;
    var Day = 0;
    var Hour = 0;
    var Minute = 0;
    var Second = 0;
    var CurrentDateMap = {
      monthDate: "",
      dayDate: "",
      hourDate: "",
      minuteDate: "",
      secondDate: ""
    };
    var CurrentDate = "";
    //初始化时间
    Year = day.getFullYear();
    Month = day.getMonth() + 1;
    Day = day.getDate();
    Hour = day.getHours();
    Minute = day.getMinutes();
    Second = day.getSeconds();
    CurrentDate = CurrentDate + Year + "-";
    if (Month >= 10) {
      CurrentDate = CurrentDate + Month;
    } else {
      CurrentDate = CurrentDate + "0" + Month;
    }
    CurrentDateMap.monthDate = CurrentDate;
    if (Day >= 10) {
      CurrentDate = CurrentDate + "-" + Day;
    } else {
      CurrentDate = CurrentDate + "-0" + Day;
    }
    CurrentDateMap.dayDate = CurrentDate;
    if (Hour >= 10) {
      CurrentDate += " " + Hour;
    } else {
      CurrentDate += " 0" + Hour;
    }
    CurrentDateMap.hourDate = CurrentDate;
    if (Minute >= 10) {
      CurrentDate = CurrentDate + ":" + Minute;
    } else {
      CurrentDate = CurrentDate + ":0" + Minute;
    }
    CurrentDateMap.minuteDate = CurrentDate;
    if (Second >= 10) {
      CurrentDate = CurrentDate + ":" + Second;
    } else {
      CurrentDate = CurrentDate + ":0" + Second;
    }
    CurrentDateMap.secondDate = CurrentDate;
    return CurrentDateMap;
  }
};
function multiwindowFn (n) {
  splitBasis = n;
  splitBasis = splitBasis == 1 ? 2 : 1;
  videoInit(videoPlayList);
}
function multiwindowFn1 (n) {
  splitBasis = n;
  splitBasis = splitBasis == 1 ? 3 : 1;
  videoInit(videoPlayList);
}
var msglog = ''
//播放的方法
function videoInit (videoPlayList) {
  msglog = ''
  if (!!videoplay && videoplay.opt.currentSource !== '') {
    videoplay.stop()
    // videoplay.destroy()
    videoplay = null
  }
  var oPlugin = {
    iWidth: $("#videoPlay").innerWidth(),
    iHeight: $("#videoPlay").innerHeight()
  };
  var url = "";
  //拼接url
  if (splitBasis != 1) {
    var num = splitBasis * splitBasis;
    for (var i = 0; i < num; i++) {
      var info = videoPlayList[i];
      if (info) {
        url +=
          "ezopen://open.ys7.com/" +
          info.deviceSerial +
          "/" +
          info.channelNo +
          ".live";
        if (videoPlayList[i + 1]) {
          url += ",";
        }
        // url += ",";
      }
      // else {
      //   url += ",";
      // }
    }
  } else {
    var info = videoPlayList[0];
    if (info) {
      url =
        "ezopen://open.ys7.com/" +
        info.deviceSerial +
        "/" +
        info.channelNo +
        ".live";
    } else {
      url = "";
    }
  }
  //播放
console.log(window.location.pathname);

  videoplay = new EZUIKit.EZUIPlayer({
    id: "videoPlay",
    autoplay: true,
    url: url,
    accessToken: accessToken,
    // 打包改变路径
    decoderPath: "/jdzcnh/static/video_plug-in/lib", //decoderPath：${window.YOUR_PATH};请在生产模式输入ezuikit.js的绝对路径
    // decoderPath: "/static/video_plug-in/lib", 
    width: oPlugin.iWidth,
    height: oPlugin.iHeight,
    splitBasis: splitBasis,
    handleError: () => {
      let elementui = require('element-ui');
      elementui.Message.warning('设备不在线')
    },
    handleSuccess: function () {
      // loadingInstance.close()
      $(".draw-window").click(function () {
        wid = $(this).attr("wid");
      });
      var oldWid = wid;
      $(".parent-wnd>div").mouseenter(function () {
        var _index = $(this).index();
        wid = _index;
        var urlList = url.split(",")
        if (!urlList[_index]) {
          return
        }
        var divStyle = "width:40px;" +
          "    height:40px;" +
          "    position:absolute;" +
          "    background:rgba(0,0,0,0.6);" +
          "    color:#fff;" +
          "    cursor:pointer;" +
          "    border-radius:10px;" +
          "    text-align:center;" +
          "    line-height:40px;" +
          "    z-index:1000;";
        var str = "<div class='top'  style='" + divStyle + "top:0;left:50%;margin-left:-20px;" + "'>▲</div>";
        str += "<div class='bottom'  style='" + divStyle + "bottom:0; left:50%;margin-left:-20px;" + "'>▼</div>";
        str += "<div class='left'  style='" + divStyle + "left:0;top:50%; margin-top:-20px;" + "'>◀</div>";
        str += "<div class='right'  style='" + divStyle + "right:0;top:50%;margin-top:-20px;" + "'>▶</div>";
        str += "<div class='zoomMax'  style='" + divStyle + "right:70px;top:0;font-size:26px;" + "'>＋</div>";
        str += "<div class='zoomMin'  style='" + divStyle + "right:20px;top:0;font-size:30px;" + "'>－</div>";
        $(this).append(str)
        $(".top").mousedown(function () {
          window.directionStart(0);
        })
        $(".top").mouseup(function () {
          window.directionStop()
        })
        $(".bottom").mousedown(function () {
          window.directionStart(1);
        })
        $(".bottom").mouseup(function () {
          window.directionStop()
        })
        $(".left").mousedown(function () {
          window.directionStart(2);
        })
        $(".left").mouseup(function () {
          window.directionStop()
        })
        $(".right").mousedown(function () {
          window.directionStart(3);
        })
        $(".right").mouseup(function () {
          window.directionStop()
        })
        $(".zoomMax").mousedown(function () {
          window.directionStart(8);
        })
        $(".zoomMax").mouseup(function () {
          window.directionStop()
        })
        $(".zoomMin").mousedown(function () {
          window.directionStart(9);
        })
        $(".zoomMin").mouseup(function () {
          window.directionStop()
        })
      })
      $(".parent-wnd>div").mouseleave(function () {
        // wid = oldWid;
        $(".top").remove();
        $(".bottom").remove();
        $(".left").remove();
        $(".right").remove();
        $(".zoomMax").remove();
        $(".zoomMin").remove();
      })
    }
  });

  // 日志输出
  videoplay.on('log', (msg) => {
    msglog = msg
    // 判断内存是否已满，满的话刷新浏览器
    if (msg.indexOf('停止播放成功') !== -1 || msg.indexOf('停止播放失败') !== -1) {
      setTimeout(logmsgfun, 3000);
    }
  });
}
function logmsgfun () {
  // console.log(msglog);
  // if (msglog.indexOf('开始播放, 第1路，地址') !== -1
  //   || msglog.indexOf('停止播放失败') !== -1
  //   || msglog.indexOf('停止播放成功') !== -1) window.location.reload()
}

var videoTime;
// $(window).resize(function () {
//   // var iW = $(".videoPlayBox").width();
//   // var iH = $(".videoPlayBox").height();
//   // console.log(iW,iH)
//   clearTimeout(videoTime)
//   videoTime = setTimeout(function () {
//     $("#videoPlay").css({
//       width: "calc(100% - 340px)",
//       height: "100%"
//     })
//     videoplay.stop();
//     videoInit(videoPlayList);
//   }, 300)
// })
//左侧功能栏收缩展开
$("#shrinkContent").unbind("click").click(function () {
  if ($("#app").hasClass("active")) {
    $("#app").removeClass("active");
    $("#videoPlay,#videoPlayTui4,#videoPlayTui9").css({
      width: "calc(100% - 360px)",
      height: "100%"
    })
  } else {
    $("#app").addClass("active");
    $("#videoPlay,#videoPlayTui4,#videoPlayTui9").css("cssText","width:calc(100% - 10px)!important;")
  }
  videoplay.stop();
  videoInit(videoPlayList);
});
var videoBoolean = true, videoTime;
//视频列表点击播放
// $(".video_list>div").unbind("click").on("click",function(event) {
//   // event.stopPropagation();
//   if(videoBoolean){
//     videoBoolean = false;
//     // event.preventDefault();
//     $(".video_list>div").removeClass("active");
//     // $(".video_list>div>img").attr("src", "../images/shexiang1.png");
//     $(this).addClass("active");
//     // $(this)
//     //   .find("img")
//     //   .attr("src", "../images/shexiang2.png");
//     var videoIndex = Number($(this).attr("index"));
//     console.log(videoIndex)
//     if (splitBasis == 1) {
//       videoPlayList[0] = videoList[videoIndex];
//     } else {
//       videoPlayList[wid] = videoList[videoIndex];
//     }
//     videoInit(videoPlayList);
//     clearTimeout(videoTime)
//     videoTime = setTimeout(function(){
//       videoBoolean = true;
//     },500)
//   }
//
// });
function videoListPlay (arr) {
  // event.stopPropagation();
  // event.preventDefault();
  if (videoBoolean) {
    videoBoolean = false;
  }
  $(".video_list>div").removeClass("active");
  // $(".video_list>div>img").attr("src", "../images/shexiang1.png");
  $(this).addClass("active");
  // $(this)
  //   .find("img")
  //   .attr("src", "../images/shexiang2.png");
  // var videoIndex = Number($(this).attr("index"));
  // console.log(videoIndex)
  // if (splitBasis == 1) {
  //   videoPlayList[0] = videoList[videoIndex];
  // } else {
  //   videoPlayList[wid] = videoList[videoIndex];
  // }
  videoPlayList = arr;
  console.log(videoPlayList)
  videoInit(videoPlayList)

}
function videoplaystop() {
  if (!!videoplay && videoplay.opt.currentSource !== '') {
    videoplay.stop()
    videoplay = null
  }
}

module.exports = { videoInitFn, videoListPlay, multiwindowFn, multiwindowFn1, videoplaystop };



//////////////////
// WEBPACK FOOTER
// ./public/video_plug-in/js/hls/main.js
// module id = 7LMC
// module chunks = 12